module.exports = __webpack_public_path__ + "img/rhopalosiphum-maidis.1b585780.jpg";